<template>
  <div class="index">
    <div class="presentation">
      <div class="title">
        <div class="sp1">了解我们的<span style="color: #F81417">产品服务</span></div>
        <div class="sp2">PRODUCT SERVICE</div>
      </div>
      <div class="content" style="justify-content: center">
        <Row type="flex" align="middle">
          <i-col span="11">
            <img src="@/assets/img/aboutUs/1.png" alt="" style="width: 100%">
          </i-col>
          <i-col span="1"></i-col>
          <i-col span="11">
            <div class="right">
              <span class="title">三益友（福州）信息技术有限公司</span> <br>
              <img src="@/assets/img/aboutUs/line.png" alt="" style="margin: 10px 0">
              <div class="des">
                专注于移动互联网应用解决方案领域<br>
                以互联网技术驱动为核心<br>
                为客户提供专业高效的产品与技术服务<br>
                我们崇尚互联网产品思维<br>
                坚信技术创造更美好的未来<br>
                不断的去发现和创造更符合用户需求的产品<br>
                致力于成为行业领先的移动互联网应用方案服务商
              </div>
            </div>
          </i-col>
        </Row>
      </div>
    </div>
    <img src="@/assets/img/home/industryBg.png" alt="" width="100%" style="display: block">
    <div style="height: 80px"></div>
    <img src="@/assets/img/aboutUs/2.png" alt="" style="width: 100%">
    <div class="team">
      <div class="title">
        <div class="sp1">我们的<span style="color: #F81417">团队</span></div>
        <div class="sp2">OUR TEAM</div>
      </div>
      <div class="content" style="justify-content: center">
        <Row  type="flex" align="middle">
          <i-col span="14">
            <img src="@/assets/img/aboutUs/4.png" alt="" style="width:100%">
          </i-col>
          <i-col span="10">
            <div class="right">
              <div>
                <div class="title1">我们的团队</div>
                <div class="des1">
                  公司由一群新鲜的80、90后组成 <br>
                  公司正在不断地成长壮大<br>
                  工作氛围轻松愉快，老板nice~
                </div>
              </div>
              <img src="@/assets/img/aboutUs/line.png" alt="">
              <div>
                <div class="title1">我们的价值观</div>
                <div class="des1">
                  公司秉着“互帮互助，共同进取”的信念，<br>
                  为每一位员工提供良好的办公氛围、福利待遇以及<br>
                  发展空间！随着公司业务不断扩大，需要多位<br>
                  专业性人才，只要觉得你想、你敢、你行，就来<br>
                  加入我们吧！
                </div>
              </div>
            </div>
          </i-col>
        </Row>

      </div>
    </div>
  </div>
</template>

<script>
  /**
   *
   * @Author zzl
   * @Date 2020/11/20 14:28.
   */

  export default {
    mounted() {

    },
    components: {},
    props: {},
    data() {
      return {}
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    beforeDestroy() {

    }
  }
</script>

<style lang="less" scoped>
  .index{
    width: 100%;
    min-width: 1920px;
    .presentation{
      width: 100%;
      background: linear-gradient(0deg, #FCFAFF, #FFFFFF);
      position: relative;
      .title {
        margin-top: 60px;
        position: relative;
        width: 100%;
        height: 110px;
        text-align: center;

        .sp1 {
          width: 100%;
          text-align: center;
          position: absolute;
          font-size: 34px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #232330;
          bottom: 0;
          z-index: 9;
        }
        .sp2 {
          width: 100%;
          text-align: center;
          position: absolute;
          font-size: 90px;
          font-family: Source Han Sans CN;
          font-weight: 800;
          color: #F6F6F6;
        }
      }
      .content{
        /*width: 1400px;*/
        height: 440px;
        display: flex;
        flex-display: row;
        margin: 80px auto 0;
        .right{
          /*padding: 0 80px;*/
          .title{
            font-size: 36px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #382C4D;
          }
          .des{
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            color: #717171;
            line-height: 40px;
          }
        }
      }
    }
    .team{
      width: 100%;
      margin-bottom: 100px;
      .title {
        margin-bottom: 100px;
        position: relative;
        width: 100%;
        height: 110px;
        text-align: center;

        .sp1 {
          width: 100%;
          text-align: center;
          position: absolute;
          font-size: 34px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #232330;
          bottom: 0;
          z-index: 9;
        }
        .sp2 {
          width: 100%;
          text-align: center;
          position: absolute;
          font-size: 90px;
          font-family: Source Han Sans CN;
          font-weight: 800;
          color: #F6F6F6;
        }
      }
      .des{
        font-size: 100px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #F6F6F6;
        position: absolute;
        top: -100px;
        left: 0;
        width: 100%;
        text-align: center;
      }
      .content{
        /*width: 1400px;*/
        display: flex;
        flex-direction: row;
        margin: 0 auto;
        .right{
          flex: 1;
          background: url("~@/assets/img/aboutUs/5.png") no-repeat;
          background-position: bottom;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 520px;
          img{
            width: 160px;
          }
          .title1{
            font-size: 30px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #382C4D;
            margin-bottom: 20px;
          }
          .des1{
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #717171;
          }
        }
      }
    }
  }
</style>
